import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText,
  FDIcon,
  FDList,
  FDListItem,
  FDListItemText,
  FDListItemTextRightAligned,
  FDPaper,
  FDSecondaryActionButton,
  FDStack,
  FDTextButton,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import usePopoverState from 'Hooks/usePopoverState';
import Popover from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Popover';
import { useRoadmapPaths } from 'Components/UI/guidedHouseholdReview/pathsContext';

export const PathComparisonPopoverButton = ({ disabled }) => {
  const {
    resource, selectedPath: selectedPathId, comparisonPaths, setComparisonPaths, exitComparisonMode,
  } = useRoadmapPaths();

  const {
    open,
    anchorEl,
    openPopover,
    handleClose,
  } = usePopoverState({});

  const togglePathIdInComparisonState = (pathId) => {
    if (comparisonPaths == null) {
      // Always add the selected Path Id by default
      const paths = [selectedPathId, pathId];
      setComparisonPaths(paths);
      return;
    }

    // If the path is in the comparison state, remove it. Otherwise, add it.
    if (comparisonPaths?.includes(pathId)) {
      setComparisonPaths(comparisonPaths?.filter((id) => id !== pathId));
    } else {
      setComparisonPaths([...comparisonPaths, pathId]);
    }
  };
  return (
    <>
      <FDSecondaryActionButton
        onClick={openPopover}
        label="Compare paths"
        icon={'arrowDropDown'}
        iconPosition={'end'}
        {...dataAttrs('roadmap-explorer-compare-path-btn')}
        size={'sm'}
        disabled={disabled}
      />
      <Popover
        id={'path-comparison-popover'}
        rounded
        open={open}
        anchorEl={anchorEl}
        onClose={(event) => {
          event.stopPropagation();
          handleClose();
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <FDPaper appearance={'elevated'} padding={2} minWidth={350} overflow={'auto'}>
          <FDStack direction={'column'} spacing={1} justifyContent={'flex-start'}>
            <FDList>
              {resource.attr('paths').resources().list().map((path) => {
                const includedInChart = comparisonPaths?.includes(path.id()) || path.id() === selectedPathId;
                // Don't let them uncheck the selected path because nothing would show on the chart
                return (
                  <FDListItem onClick={path.id() === selectedPathId ? null : () => togglePathIdInComparisonState(path.id())}>
                    <FDListItemText
                      primaryText={<FDBodyText size={'lg'} value={path.attr('name')} color={'textSecondary'} />}
                      secondaryText={<FDBodyText size={'md'} value={path.attr('description')} />}
                    />
                    {includedInChart ? (
                      <FDListItemTextRightAligned primaryText={(
                        <FDStack direction="row" justifyContent="flex-end" alignSelf={'center'}>
                          <FDIcon icon="check" color="textPrimary" />
                        </FDStack>
                      )}
                      />
                    ) : null}
                  </FDListItem>
                );
              })}
            </FDList>
            {comparisonPaths ? (
              <FDTextButton
                alignSelf={'flex-start'}
                label={'Exit comparison mode'}
                color={'textPrimary'}
                size={'md'}
                onClick={() => {
                  exitComparisonMode();
                  handleClose();
                }}
                data-test={'exit-comparison-mode-btn'}
              />
            ) : null}
          </FDStack>
        </FDPaper>
      </Popover>
    </>
  );
};

PathComparisonPopoverButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
};
